import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Kalkulator Perbedaan Antara Dua Tanggal - Hitung Perbedaan Antara Dua Tanggal dengan Akurat";
const DESCRIPTION =
  "Hitung perbedaan antara dua tanggal dalam kalender Masehi dengan akurat. Kalkulator perbedaan antara dua tanggal menampilkan perbedaan dalam tahun, bulan, hari, jam, menit, dan detik, dengan informasi tambahan yang detail";
const KEYWORDS =
  "kalkulator perbedaan antara dua tanggal, perhitungan perbedaan antara dua tanggal, perbedaan antara dua tanggal masehi, perhitungan periode antara dua tanggal, kalkulator perbedaan waktu, perhitungan perbedaan antara dua usia, perbedaan dalam hari antara dua tanggal, perhitungan periode waktu";
const OG_URL = "https://do-calculate.com/calculator/id/dategregoriandifferences/";

const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Perbedaan Antara Dua Tanggal",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Perbedaan Antara Dua Tanggal",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Bagaimana cara menghitung perbedaan antara dua tanggal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Untuk menghitung perbedaan antara dua tanggal, masukkan tanggal pertama dan tanggal kedua di kolom yang disediakan, lalu tekan tombol hitung. Hasilnya akan muncul dalam tahun, bulan, hari, jam, menit, dan detik.",
        },
      },
      {
        "@type": "Question",
        name: "Apa saja kegunaan kalkulator perbedaan antara dua tanggal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Kalkulator perbedaan antara dua tanggal digunakan untuk menghitung durasi proyek, menghitung periode waktu antara peristiwa, menghitung masa kerja atau layanan, perencanaan acara, dan menghitung perbedaan usia antara dua orang.",
        },
      },
    ],
  },
];
function DateCalculatorGregorian() {
  const [d1, setD1] = useState({ day: "7", month: "2", year: "2026" });
  const [d2, setD2] = useState({ day: "13", month: "2", year: "2026" });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);

  const calculateDifferences = () => {
    const date1 = new Date(parseInt(d1.year), parseInt(d1.month) - 1, parseInt(d1.day));
    const date2 = new Date(parseInt(d2.year), parseInt(d2.month) - 1, parseInt(d2.day));

    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      setError("Harap masukkan tanggal yang valid");
      setDifferences(null);
      return;
    }

    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    const totalMilliseconds = endDate - startDate;
    const totalSeconds = Math.floor(totalMilliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);
    const totalWeeks = Math.floor(totalDays / 7);
    const totalMonths = years * 12 + months;

    // Calculate percentage of century (100 years)
    const yearPercentage = (totalDays / (100 * 365.25)) * 100;

    setDifferences({
      years, months, days,
      hours: 0, minutes: 0, seconds: 0, // because input is in days only
      totalDays, totalWeeks, totalMonths, totalHours, totalMinutes, totalSeconds,
      startDate: startDate.toLocaleDateString("id-ID", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      endDate: endDate.toLocaleDateString("id-ID", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      yearPercentage: yearPercentage.toFixed(2),
      solarYears: (totalDays / 365.25).toFixed(2),
      workDays: Math.floor((totalDays / 7) * 5),
    });
    setError(null);
  };

  const renderSelectGroup = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 200 }, (_, i) => 2100 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div className="ltr" style={{ direction: "rtl", textAlign: "right" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />

      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
          <br />
          <div className="bg-success text-white text-center p-3 rounded shadow-sm">
            <h1 style={{ fontSize: "22px", margin: 0 }}>Kalkulator Perbedaan Antara Dua Tanggal</h1>
          </div>

          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Kalkulator Perbedaan Antara Dua Tanggal</strong> memungkinkan Anda menghitung perbedaan waktu antara dua tanggal dalam kalender Masehi dengan sangat akurat. Kalkulator menampilkan perbedaan dalam tahun, bulan, hari, jam, menit, dan detik, ditambah informasi detail yang berguna.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Hitung Perbedaan Antara Dua Tanggal</h2>
              </div>

              {renderSelectGroup(d1, setD1, "Tanggal Pertama")}
              {renderSelectGroup(d2, setD2, "Tanggal Kedua")}

              <div className="text-center mb-3 mt-4">
                <button className="btn btn-success btn-lg" style={{ padding: "10px 40px" }} onClick={calculateDifferences}>
                  Hitung Perbedaan Antara Dua Tanggal
                </button>
              </div>

              {error && <div className="alert alert-warning text-center">{error}</div>}

              {differences && (
                <div className="mt-4 animate__animated animate__fadeIn">
                  <div className="alert alert-success" style={{ color: "#155724", backgroundColor: "#d4edda", borderColor: "#c3e6cb" }}>
                    <h3 style={{ fontSize: "20px", marginBottom: "15px" }}><strong>Hasil Perhitungan Perbedaan Antara Dua Tanggal:</strong></h3>
                    <div className="mb-3 p-3 bg-light rounded text-dark border">
                      <strong style={{ fontSize: "18px" }}>Perbedaan antara kedua tanggal adalah:</strong>
                      <p style={{ fontSize: "22px", marginTop: "10px", fontWeight: "bold", color: "#28a745" }}>
                        {differences.years} tahun {differences.months} bulan {differences.days} hari
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    {/* Perbedaan secara detail */}
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>Perbedaan Secara Detail</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled" style={{ fontSize: "16px", lineHeight: "2" }}>
                            <li>✓ Tahun: {differences.years}</li>
                            <li>✓ Bulan: {differences.months}</li>
                            <li>✓ Hari: {differences.days}</li>
                            <li>✓ Jam: {differences.hours}</li>
                            <li>✓ Menit: {differences.minutes}</li>
                            <li>✓ Detik: {differences.seconds}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Statistik total */}
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>Statistik Total</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled" style={{ fontSize: "16px", lineHeight: "2" }}>
                            <li>📅 Total Hari: {differences.totalDays.toLocaleString()} hari</li>
                            <li>📅 Total Minggu: {differences.totalWeeks.toLocaleString()} minggu</li>
                            <li>📅 Total Bulan: {differences.totalMonths.toLocaleString()} bulan</li>
                            <li>⏰ Total Jam: {differences.totalHours.toLocaleString()} jam</li>
                            <li>⏰ Total Menit: {differences.totalMinutes.toLocaleString()} menit</li>
                            <li>⏰ Total Detik: {differences.totalSeconds.toLocaleString()} detik</li>
                            <li>💼 Perkiraan Hari Kerja: {differences.workDays.toLocaleString()} hari (dengan asumsi 5 hari kerja per minggu)</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Informasi detail */}
                  <div className="card mb-3 shadow-sm">
                    <div className="card-header bg-success text-white"><strong>Informasi Detail tentang Kedua Tanggal</strong></div>
                    <div className="card-body">
                      <p><strong>Tanggal Pertama:</strong> {differences.startDate}</p>
                      <p><strong>Tanggal Kedua:</strong> {differences.endDate}</p>
                      <hr />
                      <p><strong>Periode ini mewakili:</strong></p>
                      <ul style={{ lineHeight: "2" }}>
                        <li>{differences.yearPercentage}% dari satu abad (100 tahun)</li>
                        <li>{differences.solarYears} tahun matahari</li>
                        <li>{Math.floor(differences.totalDays / 30)} bulan kira-kira</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>

        <div className="col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Apa Itu Kalkulator Perbedaan Antara Dua Tanggal?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Kalkulator Perbedaan Antara Dua Tanggal</strong> adalah alat elektronik
                  canggih yang menghitung perbedaan waktu antara dua tanggal dalam kalender
                  Masehi dengan sangat akurat. Kalkulator ini didasarkan pada persamaan pemrograman yang akurat
                  yang mempertimbangkan semua faktor yang mempengaruhi seperti:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tahun kabisat dan tahun biasa</li>
                  <li>Perbedaan jumlah hari dalam bulan</li>
                  <li>Jam, menit, dan detik</li>
                  <li>Perbedaan zona waktu</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Cara Menggunakan Kalkulator:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan tanggal pertama di kolom yang disediakan</li>
                  <li>Masukkan tanggal kedua di kolom yang disediakan</li>
                  <li>Tekan tombol "Hitung Perbedaan Antara Dua Tanggal"</li>
                  <li>Hasil akan langsung muncul dengan detail lengkap</li>
                </ol>
                <p style={{ lineHeight: "1.8" }}>
                  Kalkulator secara otomatis mengurutkan tanggal, jadi tidak masalah tanggal mana yang Anda masukkan terlebih dahulu. Anda akan mendapatkan hasil nilai absolut dari perbedaan antara kedua tanggal.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Penggunaan Kalkulator Perbedaan Antara Dua Tanggal</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Penggunaan Pribadi:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Menghitung Perbedaan Usia:</strong> Mengetahui perbedaan usia
                    antara dua orang (saudara, pasangan, teman)
                  </li>
                  <li>
                    <strong>Menghitung Durasi Hubungan:</strong> Mengetahui sudah berapa lama pernikahan, pertunangan, atau persahabatan
                  </li>
                  <li>
                    <strong>Perencanaan Acara:</strong> Menghitung waktu tersisa atau
                    yang telah berlalu sejak acara tertentu
                  </li>
                  <li>
                    <strong>Kenangan:</strong> Mengetahui sudah berapa lama sejak peristiwa penting dalam hidup Anda
                  </li>
                  <li>
                    <strong>Tujuan:</strong> Menghitung durasi yang Anda habiskan untuk mencapai tujuan tertentu
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Penggunaan Profesional dan Praktis:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Manajemen Proyek:</strong> Menghitung durasi aktual proyek
                    dan membandingkannya dengan rencana
                  </li>
                  <li>
                    <strong>Sumber Daya Manusia:</strong> Menghitung masa kerja karyawan
                  </li>
                  <li>
                    <strong>Akuntansi:</strong> Menghitung periode penagihan dan pembayaran
                  </li>
                  <li>
                    <strong>Hukum:</strong> Menghitung tenggat waktu hukum dan batas waktu
                  </li>
                  <li>
                    <strong>Asuransi:</strong> Menghitung periode cakupan asuransi
                  </li>
                  <li>
                    <strong>Kontrak:</strong> Menghitung masa berlaku kontrak dan perjanjian
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Penggunaan Medis dan Kesehatan:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Menghitung usia kehamilan dengan akurat</li>
                  <li>Memantau periode pengobatan dan pemulihan</li>
                  <li>Menghitung periode antara dosis dan pemeriksaan</li>
                  <li>Melacak pertumbuhan dan perkembangan anak-anak</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Penggunaan Pendidikan:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Menghitung durasi semester atau tahun ajaran</li>
                  <li>Menghitung waktu tersisa untuk ujian</li>
                  <li>Melacak durasi studi untuk menyelesaikan gelar atau program</li>
                  <li>Merencanakan liburan sekolah</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Cara Menghitung Perbedaan Antara Dua Tanggal Secara Manual</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Menghitung perbedaan antara dua tanggal secara manual adalah proses kompleks yang memerlukan beberapa langkah:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Langkah-langkah Dasar:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Menghitung Hari:</strong> Kurangi hari pertama dari hari
                    kedua. Jika hasilnya negatif, tambahkan jumlah hari bulan sebelumnya
                    dan kurangi satu bulan.
                  </li>
                  <li>
                    <strong>Menghitung Bulan:</strong> Kurangi bulan pertama dari bulan
                    kedua. Jika hasilnya negatif, tambahkan 12 bulan dan kurangi satu tahun.
                  </li>
                  <li>
                    <strong>Menghitung Tahun:</strong> Kurangi tahun pertama dari tahun
                    kedua.
                  </li>
                </ol>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Tantangan dalam Perhitungan Manual:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Bulan yang Berbeda:</strong> Beberapa bulan memiliki 30 hari, beberapa 31 hari,
                    dan Februari 28 atau 29 hari
                  </li>
                  <li>
                    <strong>Tahun Kabisat:</strong> Perlu mempertimbangkan tahun kabisat
                    yang memiliki 366 hari
                  </li>
                  <li>
                    <strong>Jam dan Menit:</strong> Menghitung perbedaan dalam jam
                    dan menit membutuhkan akurasi yang lebih besar
                  </li>
                  <li>
                    <strong>Waktu yang Dihabiskan:</strong> Proses ini mungkin memakan waktu beberapa menit
                    dan mungkin mengandung kesalahan perhitungan
                  </li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Tips:</strong> Menggunakan kalkulator elektronik lebih cepat
                  dan lebih akurat daripada perhitungan manual. Menghemat waktu dan tenaga serta menjamin akurasi
                  100%.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Memahami Hasil dan Statistik</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Kalkulator perbedaan antara dua tanggal menampilkan serangkaian hasil
                  dan statistik lengkap yang membantu Anda memahami periode waktu dengan lebih baik:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Hasil Dasar:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Tahun, Bulan, Hari:</strong> Perbedaan dasar dalam format yang mudah dibaca
                  </li>
                  <li>
                    <strong>Jam, Menit, Detik:</strong> Untuk akurasi yang lebih besar
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Statistik Tambahan:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Total Hari:</strong> Jumlah total hari antara kedua
                    tanggal, berguna untuk perhitungan keuangan dan perencanaan
                  </li>
                  <li>
                    <strong>Total Minggu:</strong> Jumlah minggu penuh, berguna
                    untuk perencanaan mingguan
                  </li>
                  <li>
                    <strong>Total Bulan:</strong> Jumlah total bulan, berguna
                    untuk langganan dan tagihan bulanan
                  </li>
                  <li>
                    <strong>Total Jam:</strong> Jumlah total jam, berguna
                    untuk menghitung jam kerja
                  </li>
                  <li>
                    <strong>Perkiraan Hari Kerja:</strong> Jumlah hari kerja
                    (dengan asumsi 5 hari kerja per minggu), berguna untuk sumber daya manusia dan manajemen proyek
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Cara Menggunakan Statistik Ini:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    Gunakan <strong>Total Hari</strong> untuk menghitung bunga harian
                    atau sewa
                  </li>
                  <li>
                    Gunakan <strong>Total Minggu</strong> untuk merencanakan proyek
                    mingguan
                  </li>
                  <li>
                    Gunakan <strong>Total Bulan</strong> untuk langganan dan kontrak
                    bulanan
                  </li>
                  <li>
                    Gunakan <strong>Hari Kerja</strong> untuk menghitung gaji dan upah
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Tips Menggunakan Kalkulator Secara Efektif</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Tips Umum:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Pastikan Tanggal Valid:</strong> Selalu periksa bahwa
                    tanggal yang dimasukkan valid dan logis
                  </li>
                  <li>
                    <strong>Gunakan Format yang Benar:</strong> Masukkan tanggal
                    dalam format yang diminta (YYYY-MM-DD)
                  </li>
                  <li>
                    <strong>Urutan Tidak Penting:</strong> Anda dapat memasukkan tanggal terbaru
                    terlebih dahulu atau tanggal terlama terlebih dahulu, kalkulator akan menghitung perbedaan secara otomatis
                  </li>
                  <li>
                    <strong>Simpan Hasil:</strong> Jika Anda memerlukan hasil nanti,
                    ambil tangkapan layar atau salin hasilnya
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Untuk Hasil Terbaik:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Gunakan tanggal yang tepat jika tersedia</li>
                  <li>Tinjau semua statistik yang ditampilkan untuk pemahaman yang lengkap</li>
                  <li>Gunakan hasil yang sesuai dengan kebutuhan Anda (hari, minggu, bulan)</li>
                  <li>Bandingkan beberapa periode waktu jika perlu</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ Fitur:</strong> Semua perhitungan dilakukan di browser Anda secara
                  instan, memastikan privasi dan kecepatan.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Contoh Praktis Penggunaan Kalkulator</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Contoh 1: Menghitung Durasi Pernikahan
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Jika Anda menikah pada 15 Juni 2010 dan ingin mengetahui sudah berapa lama pernikahan Anda:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tanggal pertama: 2010-06-15</li>
                  <li>Tanggal kedua: Tanggal saat ini</li>
                  <li>Hasil: Anda akan mendapatkan jumlah tahun, bulan, dan hari dengan akurat</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Contoh 2: Menghitung Durasi Proyek
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Proyek Anda dimulai pada 1 Januari 2023 dan berakhir pada 31 Desember 2023:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tanggal pertama: 2023-01-01</li>
                  <li>Tanggal kedua: 2023-12-31</li>
                  <li>
                    Hasil: 364 hari (atau sekitar 11 bulan 29 hari), dengan perkiraan jumlah hari kerja
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Contoh 3: Menghitung Perbedaan Usia
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Orang pertama lahir pada 10 Maret 1990 dan yang kedua pada 25 Juli 1995:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tanggal pertama: 1990-03-10</li>
                  <li>Tanggal kedua: 1995-07-25</li>
                  <li>Hasil: Perbedaan usia antara mereka dengan tepat</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Contoh 4: Menghitung Masa Kerja
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Karyawan mulai bekerja pada 1 September 2018:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tanggal pertama: 2018-09-01</li>
                  <li>Tanggal kedua: Tanggal saat ini</li>
                  <li>
                    Hasil: Masa kerja lengkap dengan perkiraan jumlah hari kerja,
                    berguna untuk menghitung bonus dan cuti
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Pertanyaan Umum
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung perbedaan antara dua tanggal?
                </h3>
              </div>
              <div className="info-section-body">
                Untuk menghitung perbedaan antara dua tanggal menggunakan kalkulator kami, ikuti langkah-langkah berikut:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Masukkan tanggal pertama di kolom yang disediakan</li>
                  <li>Masukkan tanggal kedua di kolom yang disediakan</li>
                  <li>Tekan tombol "Hitung Perbedaan Antara Dua Tanggal"</li>
                  <li>
                    Hasil akan langsung muncul dalam tahun, bulan, hari, jam, menit, dan detik, ditambah statistik detail lainnya
                  </li>
                </ol>
                Tidak masalah tanggal mana yang Anda masukkan terlebih dahulu, kalkulator akan menghitung perbedaan absolut secara otomatis.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah saya menghitung perbedaan antara dua tanggal hanya dalam hari?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, saat menggunakan kalkulator, Anda akan mendapatkan hasil lengkap yang mencakup "Total Hari" antara kedua tanggal. Angka ini mewakili jumlah total hari antara tanggal pertama dan tanggal kedua, yang sangat berguna untuk perhitungan keuangan seperti bunga harian, atau menghitung sewa, atau melacak proyek. Selain itu, Anda juga akan mendapatkan total minggu, bulan, jam, menit, dan detik.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa saja kegunaan kalkulator perbedaan antara dua tanggal?
                </h3>
              </div>
              <div className="info-section-body">
                Kalkulator perbedaan antara dua tanggal memiliki banyak kegunaan:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Pribadi:</strong> Menghitung perbedaan usia, durasi hubungan, kenangan
                  </li>
                  <li>
                    <strong>Profesional:</strong> Manajemen proyek, menghitung masa kerja, periode penagihan
                  </li>
                  <li>
                    <strong>Hukum:</strong> Menghitung tenggat waktu hukum dan batas waktu
                  </li>
                  <li>
                    <strong>Medis:</strong> Menghitung usia kehamilan, periode pengobatan
                  </li>
                  <li>
                    <strong>Pendidikan:</strong> Durasi semester, waktu tersisa untuk ujian
                  </li>
                  <li>
                    <strong>Keuangan:</strong> Menghitung periode investasi, durasi pinjaman
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah kalkulator ini akurat dalam menghitung perbedaan antara dua tanggal?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, kalkulator kami sangat akurat. Menggunakan persamaan pemrograman canggih yang mempertimbangkan:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Tahun kabisat (yang memiliki 366 hari)</li>
                  <li>
                    Perbedaan jumlah hari dalam bulan (beberapa 30 hari, beberapa 31, dan Februari 28 atau 29)
                  </li>
                  <li>Perhitungan jam, menit, dan detik yang akurat</li>
                  <li>Semua faktor waktu lainnya</li>
                </ul>
                Kalkulator memberikan hasil 100% akurat dan instan, dan jauh lebih akurat daripada perhitungan manual yang mungkin mengandung kesalahan.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah saya menghitung perbedaan antara dua tanggal di masa lalu?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, Anda dapat menggunakan kalkulator untuk menghitung perbedaan antara dua tanggal, apakah keduanya di masa lalu atau salah satunya di masa lalu dan yang lainnya di masa depan atau sekarang. Kalkulator ini fleksibel dan menerima tanggal yang valid. Misalnya, Anda dapat menghitung berapa hari telah berlalu sejak peristiwa sejarah tertentu, atau menghitung berapa tahun antara dua tanggal di abad lalu. Selama tanggalnya valid dan logis, Anda akan mendapatkan hasil yang akurat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa yang dimaksud dengan "Perkiraan Hari Kerja" dalam hasil?
                </h3>
              </div>
              <div className="info-section-body">
                "Perkiraan Hari Kerja" adalah jumlah hari kerja yang diharapkan antara kedua tanggal, dengan asumsi minggu kerja 5 hari (dari Minggu hingga Kamis, atau dari Senin hingga Jumat tergantung negara). Ini dihitung dengan mengalikan jumlah minggu dengan 5. Angka ini adalah perkiraan karena tidak memperhitungkan hari libur resmi atau hari libur nasional. Angka ini umumnya digunakan dalam:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Menghitung gaji dan upah</li>
                  <li>Manajemen proyek dan estimasi jam kerja</li>
                  <li>Menghitung cuti dan liburan</li>
                  <li>Mengevaluasi produktivitas karyawan</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah kalkulator menyimpan data pribadi saya?
                </h3>
              </div>
              <div className="info-section-body">
                Tidak, semua perhitungan dilakukan sepenuhnya di browser Anda (client-side), dan tidak ada data yang dikirim ke server kami. Ini berarti:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Privasi Anda sepenuhnya terlindungi</li>
                  <li>Kami tidak menyimpan tanggal apa pun yang Anda masukkan</li>
                  <li>Kami tidak melacak penggunaan kalkulator Anda</li>
                  <li>Anda dapat menggunakan kalkulator dengan penuh keyakinan</li>
                </ul>
                Anda bahkan dapat menggunakan kalkulator tanpa koneksi internet setelah memuat halaman untuk pertama kalinya.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung jumlah hari kerja aktual (dengan mengecualikan hari libur)?
                </h3>
              </div>
              <div className="info-section-body">
                Kalkulator memberi Anda "Perkiraan Hari Kerja" yang mengasumsikan minggu kerja 5 hari. Untuk menghitung hari kerja aktual dengan mengecualikan hari libur dan hari raya resmi, Anda dapat:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Gunakan hasil perkiraan dari kalkulator</li>
                  <li>Kurangi jumlah hari libur resmi di negara Anda selama periode tersebut</li>
                  <li>Kurangi hari cuti sakit atau cuti pribadi jika ada</li>
                </ol>
                Contoh: Jika kalkulator memberi Anda 260 hari kerja perkiraan, dan ada 10 hari libur resmi, maka hari kerja aktual = 260 - 10 = 250 hari kerja.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DateCalculatorGregorian;